import { Color } from "../../types";

export const COLOR_PICKER_COLORS: Color[] = [
  "#522258",
  "#8C3061",
  "#C63C51",
  "#D95F59",
  "#021526",
  "#03346E",
  "#6EACDA",
  "#77E4C8",
  "#36C2CE",
  "#478CCF",
  "#4535C1",
  "#E9FF97",
  "#FFD18E",
  "#FFA38F",
  "#FF7EE2",
];
